// @ts-strict-ignore
const getInvalidVINLetter = (vin = '') => vin.match(/[ioq]/gi)?.[0]?.toUpperCase() ?? '';

// FE vin validation, not absolute vin validation
const isVinValid = (vin = '') => !getInvalidVINLetter(vin) && vin.length === 17;

export { getInvalidVINLetter, isVinValid };
